module.exports = __webpack_public_path__ + "img/01.3d9d0335.jpg";